import React, { useState, useEffect } from 'react'; // Add useState and useEffect
import { motion } from 'framer-motion';
import { Pagination } from 'swiper/modules'; // Add Autoplay
import { Swiper, SwiperSlide } from 'swiper/react';
import { gallery11 } from '../assets';
import 'swiper/css';
import 'swiper/css/pagination';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const Story = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section className="py-32 px-8">
      <div className="mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h2 className="text-5xl md:text-7xl mb-6 text-pink">Our Story</h2>
          <div className="mt-12 space-y-8">
            <div className="relative mt-12 py-8 px-8 border-l-[3px] border-r-[3px] border-gold">
              <div className="absolute -top-4 left-4 text-6xl text-gold/20 font-serif">"</div>
              <p className="text-2xl md:text-3xl font-display italic text-sage-dark leading-relaxed">
                I have found the one whom my soul loves. <br/> <small>Song of Solomon 3:4</small>
              </p>
              <div className="absolute -bottom-4 right-4 text-6xl text-gold/20 font-serif rotate-180">"</div>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="mb-16 mt-20 rounded overflow-hidden"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          {isMobile ? (
            <>
              {/* Mobile: Swiper with autoplay, starts at slide 2 */}
              <Swiper
                modules={[Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                pagination={{
                  clickable: true,
                  el: '.swiper-pagination-custom',
                }}
                initialSlide={1}
                className="wedding-swiper"
              >
                <SwiperSlide>
                  <div className="relative h-[660px] text-center">
                    <h2 className='text-7xl mb-8'>Caleb</h2>
                    <p className='text-justify'>
                      It began in 2019, when I met my elementary school friend once again.
                      We had never really spoken back then—but perhaps, even at that moment, our paths were already quietly being paved.
                      <br /><br />
                      What started as small conversations slowly grew into care for one another—
                      shared cinemas, late-night food cravings, simple moments that meant everything.
                      Day by day, I fell deeper, and without realizing it, she became my home—
                      a place where I found comfort, warmth, and unwavering support.
                      <br /><br />
                      She is the one who brought color into my life with her laughter and joy.
                      And in her, I found the only soul who could paint the rest of my life with meaning.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="relative h-[660px] py-4 md:p-4">
                    <img
                      src={gallery11}
                      alt=""
                      className="w-full h-full rounded-xl object-cover mb-4"
                    />
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="relative h-[660px] text-center">
                    <h2 className='text-7xl mb-8'>Alyssa</h2>
                    <p className='text-justify'>
                      Who would’ve thought I’d end up marrying my elementary school friend?
                      It started with a small moment that showed how attentive he is,
                      and from there… the conversation just kept going.
                      <br /><br />
                      Caleb is very sweet, fun, and always thoughtful in his own way.
                      He loves me in the gentlest ways, and he always gets me.
                      <br /><br />
                      After 6 years of growing together,
                      I never had to question where this was going…
                      because with him, it has always felt right.
                      Loving him is being surrounded by little moments that always make my heart happy.
                      <br /><br />
                      So… here we are 🤍
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              {/* Custom pagination at bottom */}
              <div className="swiper-pagination-custom mt-6 flex justify-center"></div>

              <div className="flex items-center justify-center text-sage gap-4">
                <FaArrowLeft className='animate-scroll-hz-revert-pulse' />
                Swipe for our story
                <FaArrowRight className='animate-scroll-hz-pulse' />
              </div>
            </>
          ) : (
            // Desktop: Show all 3 slides in a grid
            <div className="grid grid-cols-3 gap-12">
              <div className="relative h-[600px]">
                <div className="relative h-[600px] text-center">
                  <h2 className='text-7xl mb-8'>Caleb</h2>
                  <p>
                    It began in 2019, when I met my elementary school friend once again.
                    We had never really spoken back then—but perhaps, even at that moment, our paths were already quietly being paved.
                    <br /><br />
                    What started as small conversations slowly grew into care for one another—
                    shared cinemas, late-night food cravings, simple moments that meant everything.
                    Day by day, I fell deeper, and without realizing it, she became my home—
                    a place where I found comfort, warmth, and unwavering support.
                    <br /><br />
                    She is the one who brought color into my life with her laughter and joy.
                    And in her, I found the only soul who could paint the rest of my life with meaning.
                  </p>
                </div>
              </div>

              <div className="relative h-[600px]">
                <img
                  src={gallery11}
                  alt=""
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>

              <div className="relative h-[600px]">
                <div className="relative h-[600px] text-center">
                  <h2 className='text-7xl mb-8'>Alyssa</h2>
                  <p className='text-justify'>
                    Who would’ve thought I’d end up marrying my elementary school friend?
                    It started with a small moment that showed how attentive he is,
                    and from there… the conversation just kept going.
                    <br /><br />
                    Caleb is very sweet, fun, and always thoughtful in his own way.
                    He loves me in the gentlest ways, and he always gets me.
                    <br /><br />
                    After 6 years of growing together,
                    I never had to question where this was going…
                    because with him, it has always felt right.
                    Loving him is being surrounded by little moments that always make my heart happy.
                    <br /><br />
                    So… here we are 🤍
                  </p>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default Story;
